<template>
	<div class="multi-inputbox">
		<el-select
			:multiple="true"
			:disable="isDisabled"
			v-model="tagList"
			:placeholder="placeholder"
			:popper-append-to-body="false"
			@change="onChange"
			:size="size">
			<el-option
				v-for="(item,index) in optionList"
				:key="index"
				:label="item.label"
				:value="item.value">
			</el-option>
		</el-select>
	</div>
</template>

<script>
export default {
    name: 'multi-inputbox',
    model: {
        prop: 'modelval',
        event: 'change'
    },
    inject: {elForm: {default: {}}},
    props: {
        modelval: [String, Object, Array],
        /* 标签显示的字段 */
        tagLabelField: String,
        /* 是否可禁用 */
        disabled: Boolean,
        /* 标签大小 */
        size: String,
        /* 数据为空时的提示消息*/
        placeholder: String
    },
    data() {
        return {
            /* 标签列表 */
            tagList: [],
            /* 选择的数据 */
            selected: []
        };
    },
    computed: {
        isDisabled(){
            return this.disabled || this.elForm.disabled;
        },
        optionList(){
            var arr = this.selected || [];
            var rslt = [];
            for(var i=0; i<arr.length; i++){
                var row = arr[i];
                var label = this.tagLabelField
                    ?row && row[this.tagLabelField] || ' '
                    :' ';
                rslt.push({
                    value: i,
                    label: label
                });
            }
            return rslt;
        }
    },
    watch: {
        modelval: {
            immediate: true,
            handler: function (val) {
                this.selected = Array.isArray(val)?val:[];
                this.getTagList(this.selected);
            }
        }
    },
    methods: {
        /**
         * @method：onChange
         * @createdBy:HuangJian
         * @date:2019/1/22
         * @params：
         * val:变化后的值
         * @description：响应标签内部的变化
         */
        onChange(val){
            var indexs = val || [];
            var newModel = [];
            indexs.forEach((index) => {
                newModel.push(this.selected[index]);
            });
            this.selected = newModel;
            this.$emit('change', newModel);
        },
        /**
         * @method：getTagList
         * @createdBy:HuangJian
         * @date:2019/1/22
         * @params：
         * @description：生成TagList
         */
        getTagList(arr){
            arr = Array.isArray(arr)?arr:[];
            var rslt = [];
            for(var i=0; i<arr.length; i++){
                rslt.push(i);
            }
            this.tagList = rslt;
        },
        /**
         * @method：getCaretEl
         * @createdBy:HuangJian
         * @date:2019/1/22
         * @params：
         * @description：获取右边点击按钮
         */
        getCaretEl(){
            const selector = '.el-select .el-input__suffix .el-input__suffix-inner .el-select__caret';
            return this.$el.querySelector(selector);
        },
        /**
         * @method：handleIconClick
         * @createdBy:HuangJian
         * @date:2019/1/22
         * @params：
         * @description：响应右边按钮的点击事件
         */
        handleIconClick(){
            if(!this.isDisabled){
                this.$emit('icon-click');
            }
        }
    },
    mounted(){
        const el = this.getCaretEl();
        if(el){
            el.addEventListener('click', this.handleIconClick);
        }
    },
    beforeDestroy(){
        const el = this.getCaretEl();
        if(el){
            el.removeEventListener('click', this.handleIconClick);
        }
    }
};
</script>

<style lang="scss" scoped>
    .multi-inputbox {
        /deep/ {
			.el-select-dropdown.el-popper.is-multiple{
				display: none!important;
			}
			.el-input__suffix .el-input__suffix-inner {
			}
            .el-select__caret:before{
				content: "\e778"!important;
            }
            .el-select__caret{
                transform:rotateZ(0)!important;
            }
        }
    }
</style>
